import React, { useState, useEffect, useRef } from "react";
import "./Planner.css";
import "../hooks/useRipple.css";
import useRipple from "../hooks/useRipple";
import UploadPopUp from "../shared/components/UploadModal/UploadPopUp";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { motion, AnimatePresence } from "motion/react";
import { getAccountType, getUserSchoolId } from "../store/auth/selectors";
import { checkPermission } from "../shared/utils/permissions";
import { PERMISSION_TYPES } from "../shared/utils/permissions";
import InputComponent from "../shared/components/DynamicInput/DynamicInput";
import EventCard from "../shared/components/EventCard/EventCard";
import CreateEventFormPopup from "../shared/components/CreateEventForm/CreateEventFormPopup";
import EventDetailsPopup from "../shared/components/EventDetailsPopup/EventDetailsPopup";
import DeleteEventPopup from "../shared/components/DeleteEventPopup/DeleteEventPopup";
import useEventsQueries from "../store/events/eventsQueries";
import { formatDate } from "../shared/utils/formatDate";
import { config } from "./Plannerconfig";
import loader from "../assets/gifs/loader.gif";
import resetIcon from "../assets/images/reset_icon.svg";
import noDataArt from "../assets/images/no_data_art.svg";
import line from "../assets/images/line.svg";
import dropdown_icon from "../assets/images/dropdown_icon.svg";
import { CONFIG_VARS } from "../constants/urlConstants/configuration";
import RefreshIcon from "@mui/icons-material/Refresh";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

const selectdata = {
  option1: [
    { label: "Option 1", value: "1" },
    { label: "Option 2", value: "2" },
  ],
  option2: [
    { label: "grade 1", value: "1" },
    { label: "grade 2", value: "2" },
    { label: "grade 3", value: "3" },
    { label: "grade 4", value: "4" },
    { label: "grade 5", value: "5" },
    { label: "grade 6", value: "6" },
    { label: "grade 7", value: "7" },
    { label: "grade 8", value: "8" },
    { label: "grade 9", value: "9" },
    { label: "grade 10", value: "10" },
  ],
  option3: [
    { label: "All", value: "ALL" },
    { label: "Academic", value: "ACADEMIC" },
    { label: "Extra Curricular", value: "EXTRA_CURRICULAR" },
  ],
};

const Planner = () => {
  const accountType = useSelector(getAccountType);
  const userSchoolId = useSelector(getUserSchoolId);
  const navigate = useNavigate();
  const checkUserPermission = (permissionType) =>
    checkPermission(accountType, permissionType);

  const createEventPopupRef = useRef(null);
  const editDeleteEventPopupRef = useRef(null);
  const globalEventsDropdownRef = useRef(null);
  const refreshButtonRef = useRef(null);
  useRipple(refreshButtonRef);
  const createEventButtonRef = useRef(null);
  useRipple(createEventButtonRef);
  const globalEventsButtonRef = useRef(null);
  useRipple(globalEventsButtonRef);
  const editDeleteButtonRef = useRef(null);
  useRipple(editDeleteButtonRef);

  const handleClickOutside = (event) => {
    if (
      createEventPopupRef.current &&
      !createEventPopupRef.current.contains(event.target) &&
      !(
        createEventButtonRef.current &&
        createEventButtonRef.current.contains(event.target)
      )
    ) {
      setIsCreateEventPopupMenuVisible(false);
    }
    if (
      editDeleteEventPopupRef.current &&
      !editDeleteEventPopupRef.current.contains(event.target) &&
      !(
        editDeleteButtonRef.current &&
        editDeleteButtonRef.current.contains(event.target)
      )
    ) {
      setIsEditDeleteEventPopupMenuVisible(false);
    }
    if (
      globalEventsDropdownRef.current &&
      !globalEventsDropdownRef.current.contains(event.target) &&
      !(
        globalEventsButtonRef.current &&
        globalEventsButtonRef.current.contains(event.target)
      )
    ) {
      setIsGlobalEventsDropdownVisible(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const [isPopupVisible, setIsPopupVisible] = useState(false);
  const [isCreateEventPopupMenuVisible, setIsCreateEventPopupMenuVisible] =
    useState(false);
  const [
    isEditDeleteEventPopupMenuVisible,
    setIsEditDeleteEventPopupMenuVisible,
  ] = useState(false);
  const [isGlobalEventsDropdownVisible, setIsGlobalEventsDropdownVisible] =
    useState(false);
  const [isEventDetailsVisible, setIsEventDetailsVisible] = useState(false);
  const [isDeletePopupVisible, setIsDeletePopupVisible] = useState(false);
  const [isUploadModalVisible, setIsUploadModalVisible] = useState(false);
  const [uploadType, setUploadType] = useState(null);
  const [selectedEventDetails, setSelectedEventDetails] = useState(null);
  const [isDeleteMode, setIsDeleteMode] = useState(false);
  const [schoolInput, setSchoolInput] = useState("");
  const [schoolOptions, setSchoolOptions] = useState([]);
  const [gradeOptions, setGradeOptions] = useState([]);
  const [selectedSchool, setSelectedSchool] = useState(null);
  const [selectedGrade, setSelectedGrade] = useState(null);
  const [selectedEvent, setSelectedEvent] = useState("ALL");
  const [isLoading, setIsLoading] = useState(false);
  const [eventsData, setEventsData] = useState([]);
  const [allEventsData, setAllEventsData] = useState([]);
  const [showCopyNotification, setShowCopyNotification] = useState(false);

  const {
    handleGetAllEvents,
    handleGetAllGrades,
    handleSearchSchools,
    handleDeleteEvent,
  } = useEventsQueries();

  const handleCreateEventClick = () => {
    if (checkUserPermission(PERMISSION_TYPES.CREATE_EVENT)) {
      setIsCreateEventPopupMenuVisible((prev) => {
        const next = !prev;
        if (next) {
          setIsEditDeleteEventPopupMenuVisible(false);
          setIsGlobalEventsDropdownVisible(false);
        }
        return next;
      });
    }
  };

  const handleEditDeleteClick = () => {
    if (
      checkUserPermission(PERMISSION_TYPES.RESCHEDULE_EVENTS) &&
      checkUserPermission(PERMISSION_TYPES.DELETE_EVENTS)
    ) {
      setIsEditDeleteEventPopupMenuVisible((prev) => {
        const next = !prev;
        if (next) {
          setIsCreateEventPopupMenuVisible(false);
          setIsGlobalEventsDropdownVisible(false);
        }
        return next;
      });
    }
  };

  const handleGlobalEventsClick = () => {
    setIsGlobalEventsDropdownVisible((prev) => {
      const next = !prev;
      if (next) {
        setIsCreateEventPopupMenuVisible(false);
        setIsEditDeleteEventPopupMenuVisible(false);
      }
      return next;
    });
  };

  const handleGlobalEventsOptionClick = (option) => {
    setIsGlobalEventsDropdownVisible(false);
    const levelParam = option.toLowerCase().replace(/\s+/g, "-");
    navigate(`/global-events/${levelParam}`);
  };

  const handleBulkEditEventClick = () => {
    setIsEditDeleteEventPopupMenuVisible(false);
    setUploadType("eventReschedule");
    setIsUploadModalVisible(true);
  };

  const handleBulkDeleteEventClick = () => {
    setIsEditDeleteEventPopupMenuVisible(false);
    setUploadType("eventDelete");
    setIsUploadModalVisible(true);
  };

  const handleCreateSingleEventClick = () => {
    setIsCreateEventPopupMenuVisible(false);
    setIsPopupVisible(true);
  };

  const handleCreateBulkEventClick = () => {
    setIsCreateEventPopupMenuVisible(false);
    setUploadType("eventCreate");
    setIsUploadModalVisible(true);
  };

  const handleCloseUploadModal = () => {
    setIsUploadModalVisible(false);
    setUploadType(null);
  };

  const handleViewEventDetails = (event) => {
    if (checkUserPermission(PERMISSION_TYPES.VIEW_EVENT_DETAILS)) {
      setSelectedEventDetails(event);
      setIsEventDetailsVisible(true);
    }
  };

  const handleCloseEventDetails = () => {
    setIsEventDetailsVisible(false);
    setSelectedEventDetails(null);
  };

  const handleDeleteModeToggle = () => {
    if (checkUserPermission(PERMISSION_TYPES.DELETE_EVENTS)) {
      setIsDeleteMode(!isDeleteMode);
    }
  };

  const handleDeleteClick = (event) => {
    if (checkUserPermission(PERMISSION_TYPES.DELETE_EVENTS)) {
      setSelectedEventDetails(event);
      setIsDeletePopupVisible(true);
    }
  };

  const handleDeleteConfirm = async (eventId) => {
    try {
      await handleDeleteEvent(eventId);
      setIsDeletePopupVisible(false);
      if (selectedSchool && selectedGrade) {
        await fetchEventsForSchoolAndGrade(
          selectedSchool.value,
          selectedGrade.value,
        );
      }
    } catch (error) {
      console.error("Error deleting event:", error);
    }
  };

  const handleSchoolInputChange = (value) => {
    setSchoolInput(value);
    setSelectedSchool(null);
  };

  const handleSchoolSelect = async (school) => {
    setSelectedSchool(school);
    await fetchEventsForSchoolAndGrade(
      school.value,
      selectedGrade?.value || gradeOptions[0]?.value,
    );
  };

  const handleGradeSelect = async (grade) => {
    setSelectedGrade(grade);
    if (!selectedSchool) return;
    await fetchEventsForSchoolAndGrade(selectedSchool.value, grade.value);
  };

  const handleEventSelect = (event) => {
    const eventType = event?.value;
    setSelectedEvent(eventType);
  };

  const filterEvents = (eventType) => {
    if (eventType === "ALL") {
      setEventsData(allEventsData);
      return;
    }

    const filteredData = allEventsData
      .map((dateGroup) => {
        const filteredEvents = dateGroup.events.filter((event) => {
          return event.specification?.event_type === eventType;
        });

        return {
          ...dateGroup,
          events: filteredEvents,
        };
      })
      .filter((dateGroup) => dateGroup.events.length > 0);

    setEventsData(filteredData);
  };

  const handleResetFilters = () => {
    if (!checkUserPermission(PERMISSION_TYPES.RESET_FILTER)) return;

    const defaultGrade = gradeOptions[3];
    setSelectedGrade(defaultGrade);
    setSelectedEvent("ALL");
    setEventsData([]);
    setAllEventsData([]);
    setIsDeleteMode(false);

    // For non School Admin, also clear school
    if (accountType !== "School Admin") {
      setSchoolInput("");
      setSelectedSchool(null);
    }
  };

  const fetchEventsForSchoolAndGrade = async (schoolId, gradeId) => {
    if (!schoolId || !gradeId) return;

    const schoolIdValue = schoolId.match(/\((.*?)\)/)
      ? schoolId.match(/\((.*?)\)/)[1]
      : "";

    setIsLoading(true);
    const eventsResponse = await handleGetAllEvents({
      date_range_start: "2020-01-01T17:49:28.135Z",
      date_range_end: "2040-10-24T17:49:28.135Z",
      event_type: "ALL",
      target_groups: [{ school_id: schoolIdValue, grade: gradeId }],
    });
    setIsLoading(false);

    if (eventsResponse && eventsResponse.length > 0) {
      // Get role IDs from config
      const hierarchy = CONFIG_VARS.hierarchy_role_ids || {};
      const firstEnv = Object.values(hierarchy)[0] || {};
      const seniorManagerRoleId = firstEnv["Senior Manager"]; // Should be 47
      const managerRoleId = firstEnv["Manager"]; // Should be 48
      const executionRepRoleId = firstEnv["Execution Rep"]; // Should be 49

      const formattedEvents = eventsResponse.map((event) => {
        let rep1 = null;
        let rep2 = null;
        let rep3 = null;

        if (event.poc_array && event.poc_array.length > 0) {
          // First try to assign by role
          event.poc_array.forEach((poc) => {
            // Check if roles array exists and has at least one role
            if (poc.roles && poc.roles.length > 0) {
              const primaryRoleId = poc.roles[0]; // Taking first role as primary

              if (primaryRoleId === seniorManagerRoleId) {
                rep1 = `${poc.first_name || ""} ${poc.last_name || ""}`.trim();
              } else if (primaryRoleId === managerRoleId) {
                rep2 = `${poc.first_name || ""} ${poc.last_name || ""}`.trim();
              } else if (primaryRoleId === executionRepRoleId) {
                rep3 = `${poc.first_name || ""} ${poc.last_name || ""}`.trim();
              }
            }
          });

          // Fallback to array positions if no role assignments were made
          if (!rep1 && !rep2 && !rep3) {
            if (event.poc_array[0]) {
              rep1 = `${event.poc_array[0].first_name || ""} ${
                event.poc_array[0].last_name || ""
              }`.trim();
            }
            if (event.poc_array[1]) {
              rep2 = `${event.poc_array[1].first_name || ""} ${
                event.poc_array[1].last_name || ""
              }`.trim();
            }
            if (event.poc_array[2]) {
              rep3 = `${event.poc_array[2].first_name || ""} ${
                event.poc_array[2].last_name || ""
              }`.trim();
            }
          }
        }

        return {
          timestamp: new Date(event.start_date_time).getTime(),
          date: formatDate(event.start_date_time),
          details: {
            id: event._id,
            school_name: event.target_groups[0].school_id,
            grade: event.target_groups[0].grade,
            event_code: event.event_code,
            event_type: event.specification.event_type,
            name: event.name,
            description: event.description,
            provider_metadata: event.provider_metadata,
            start_date_time: event.start_date_time,
            end_date_time: event.end_date_time,
            level: event.specification?.level,
            round: event.specification?.round,
            exam_name: event.exam_details?.exam_name,
            is_editable_by_school_admin: event.is_editable_by_school_admin,
            is_archived: event.is_archived,
            is_imported: event.is_imported,
            specification: event.specification,
            timezone: event.event_timezone,
            is_paid_report:
              event.specification?.credit_requirement.is_paid_report,
            rep1,
            rep2,
            rep3,
            poc_array: event.poc_array,
          },
        };
      });

      // Rest of your existing code for sorting and grouping...
      formattedEvents.sort((a, b) => a.timestamp - b.timestamp);

      const groupedEvents = formattedEvents.reduce((acc, event) => {
        const { date, details } = event;
        if (!acc[date]) acc[date] = [];

        const duplicateExists = acc[date].some(
          (existingEvent) =>
            existingEvent.event_code === details.event_code &&
            existingEvent.level === details.level &&
            existingEvent.round === details.round &&
            existingEvent.start_date_time === details.start_date_time,
        );

        if (!duplicateExists) {
          acc[date].push(details);
        }
        return acc;
      }, {});

      const sortedEventsData = Object.entries(groupedEvents)
        .map(([date, events]) => ({
          date,
          events,
          timestamp: new Date(events[0].start_date_time).getTime(),
        }))
        .sort((a, b) => a.timestamp - b.timestamp)
        .map(({ date, events }) => ({ date, events }));

      setAllEventsData(sortedEventsData);
    } else {
      setAllEventsData([]);
      setEventsData([]);
    }
  };
  useEffect(() => {
    if (allEventsData.length > 0) {
      filterEvents(selectedEvent);
    }
  }, [selectedEvent, allEventsData]);

  useEffect(() => {
    const fetchGrades = async () => {
      const response = await handleGetAllGrades();
      if (response) {
        const formattedGrades = response.map((grade) => ({
          label: grade.grade_name,
          value: grade.grade_id.toString(),
        }));
        setGradeOptions(formattedGrades);
        setSelectedGrade(formattedGrades[3]);
      }
    };

    fetchGrades();
  }, []);

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      if (schoolInput.length >= 3) {
        fetchSchoolOptions(schoolInput);
      }
    }, 300);

    return () => clearTimeout(delayDebounceFn);
  }, [schoolInput]);

  const fetchSchoolOptions = async (searchedSchool) => {
    const response = await handleSearchSchools(searchedSchool);
    if (response) {
      const formattedSchools = response.data.map((school) => ({
        label: `${school._source.school_name} - (${school._source.school_id})`,
        value: `${school._source.school_name} - (${school._source.school_id})`,
      }));
      setSchoolOptions(formattedSchools);
    }
  };

  // Autofill and lock school for School Admin
  useEffect(() => {
    const initializeForSchoolAdmin = async () => {
      if (accountType === "School Admin" && userSchoolId && !selectedSchool) {
        const id = userSchoolId.toUpperCase();
        setSchoolInput(id);
        const response = await handleSearchSchools(id);
        if (response?.data?.length) {
          const option = response.data
            .map((s) => ({
              label: `${s._source.school_name} - (${s._source.school_id})`,
              value: `${s._source.school_name} - (${s._source.school_id})`,
            }))
            .find((opt) => opt.value.includes(`(${id})`));
          if (option) {
            await handleSchoolSelect(option);
          }
        }
      }
    };
    initializeForSchoolAdmin();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [accountType, userSchoolId]);

  const canCreateEvent = checkUserPermission(PERMISSION_TYPES.CREATE_EVENT);
  const canEditDeleteEvents =
    checkUserPermission(PERMISSION_TYPES.RESCHEDULE_EVENTS) &&
    checkUserPermission(PERMISSION_TYPES.DELETE_EVENTS);
  const canViewGlobalStudentDetails = checkUserPermission(
    PERMISSION_TYPES.VIEW_GLOBAL_STUDENT_DETAILS,
  );
  return (
    <>
      <div className="planner-mainCont">
        <div className="headerCont">
          <div className="titlecont">
            <h3>Planner</h3>
            <p>Manage your Planner</p>
          </div>
          <div className="buttonCont">
            {canViewGlobalStudentDetails && (
              <div style={{ position: "relative" }}>
                <button
                  ref={globalEventsButtonRef}
                  className={`dark_btn`}
                  onClick={handleGlobalEventsClick}
                  style={{
                    backgroundColor: "#007BFF",
                    color: "#FFFFFF",
                    position: "relative",
                    overflow: "hidden",
                  }}
                  aria-haspopup="true"
                  aria-expanded={isGlobalEventsDropdownVisible}
                  aria-controls="planner-global-events-menu"
                >
                  GLOBAL EVENTS
                  <motion.img
                    src={dropdown_icon}
                    animate={{
                      rotate: isGlobalEventsDropdownVisible ? 180 : 0,
                    }}
                    transition={{ duration: 0.3, ease: "easeInOut" }}
                    style={{ filter: "brightness(0) invert(1)" }}
                  />
                </button>
                <AnimatePresence>
                  {isGlobalEventsDropdownVisible && (
                    <motion.div
                      className="popup-menu-event global-events-menu"
                      ref={globalEventsDropdownRef}
                      id="planner-global-events-menu"
                      initial={{
                        opacity: 0,
                        scale: 0.8,
                        y: -10,
                        pointerEvents: "none",
                      }}
                      animate={{
                        opacity: 1,
                        scale: 1,
                        y: 0,
                        pointerEvents: "auto",
                      }}
                      exit={{
                        opacity: 0,
                        scale: 0.8,
                        y: -10,
                        pointerEvents: "none",
                      }}
                      transition={{
                        type: "spring",
                        stiffness: 300,
                        damping: 20,
                        duration: 0.3,
                      }}
                      style={{
                        backgroundColor: "#F8F9FA",
                        border: "1px solid #E3F2FD",
                      }}
                    >
                      <motion.div
                        className="popup-menu-button"
                        onClick={() =>
                          handleGlobalEventsOptionClick("Semi-Finals")
                        }
                        whileTap={{ scale: 0.98 }}
                        transition={{
                          type: "spring",
                          stiffness: 400,
                          damping: 25,
                        }}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                        }}
                        onMouseEnter={(e) => {
                          e.target.style.backgroundColor = "#007BFF";
                          e.target.style.color = "#FFFFFF";
                        }}
                        onMouseLeave={(e) => {
                          e.target.style.backgroundColor = "transparent";
                          e.target.style.color = "#495057";
                        }}
                      >
                        Semi-Finals
                        <ArrowForwardIcon
                          style={{ marginLeft: "8px", fontSize: "16px" }}
                        />
                      </motion.div>
                      <motion.div
                        className="popup-menu-button"
                        onClick={() => handleGlobalEventsOptionClick("Finals")}
                        whileTap={{ scale: 0.98 }}
                        transition={{
                          type: "spring",
                          stiffness: 400,
                          damping: 25,
                        }}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                        }}
                        onMouseEnter={(e) => {
                          e.target.style.backgroundColor = "#007BFF";
                          e.target.style.color = "#FFFFFF";
                        }}
                        onMouseLeave={(e) => {
                          e.target.style.backgroundColor = "transparent";
                          e.target.style.color = "#495057";
                        }}
                      >
                        Finals
                        <ArrowForwardIcon
                          style={{ marginLeft: "8px", fontSize: "16px" }}
                        />
                      </motion.div>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            )}
            {canEditDeleteEvents && (
              <div style={{ position: "relative" }}>
                <button
                  ref={editDeleteButtonRef}
                  className={`light_btn`}
                  onClick={handleEditDeleteClick}
                  style={{ position: "relative", overflow: "hidden" }}
                  aria-haspopup="true"
                  aria-expanded={isEditDeleteEventPopupMenuVisible}
                  aria-controls="planner-edit-delete-menu"
                >
                  EDIT/DELETE
                  <motion.img
                    src={dropdown_icon}
                    animate={{
                      rotate: isEditDeleteEventPopupMenuVisible ? 180 : 0,
                    }}
                    transition={{ duration: 0.3, ease: "easeInOut" }}
                  />
                </button>
                <AnimatePresence>
                  {isEditDeleteEventPopupMenuVisible && (
                    <motion.div
                      className="popup-menu-event"
                      ref={editDeleteEventPopupRef}
                      id="planner-edit-delete-menu"
                      initial={{
                        opacity: 0,
                        scale: 0.8,
                        y: -10,
                        pointerEvents: "none",
                      }}
                      animate={{
                        opacity: 1,
                        scale: 1,
                        y: 0,
                        pointerEvents: "auto",
                      }}
                      exit={{
                        opacity: 0,
                        scale: 0.8,
                        y: -10,
                        pointerEvents: "none",
                      }}
                      transition={{
                        type: "spring",
                        stiffness: 300,
                        damping: 20,
                        duration: 0.3,
                      }}
                    >
                      <motion.div
                        className="popup-menu-button"
                        onClick={handleBulkEditEventClick}
                        whileTap={{ scale: 0.98 }}
                        transition={{
                          type: "spring",
                          stiffness: 400,
                          damping: 25,
                        }}
                      >
                        Bulk Reschedule Event
                      </motion.div>
                      <motion.div
                        className="popup-menu-button"
                        onClick={handleBulkDeleteEventClick}
                        whileTap={{ scale: 0.98 }}
                        transition={{
                          type: "spring",
                          stiffness: 400,
                          damping: 25,
                        }}
                      >
                        Bulk Delete Event
                      </motion.div>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            )}
            {canCreateEvent && (
              <div style={{ position: "relative" }}>
                <button
                  ref={createEventButtonRef}
                  onClick={handleCreateEventClick}
                  className="dark_btn"
                  style={{ position: "relative", overflow: "hidden" }}
                  aria-haspopup="true"
                  aria-expanded={isCreateEventPopupMenuVisible}
                  aria-controls="planner-create-event-menu"
                >
                  Create Event
                  <motion.img
                    src={dropdown_icon}
                    style={{ filter: "brightness(0) invert(1)" }}
                    animate={{
                      rotate: isCreateEventPopupMenuVisible ? 180 : 0,
                    }}
                    transition={{ duration: 0.3, ease: "easeInOut" }}
                  />
                </button>
                <AnimatePresence>
                  {isCreateEventPopupMenuVisible && (
                    <motion.div
                      className="popup-menu-event create-menu"
                      ref={createEventPopupRef}
                      id="planner-create-event-menu"
                      initial={{
                        opacity: 0,
                        scale: 0.8,
                        y: -10,
                        pointerEvents: "none",
                      }}
                      animate={{
                        opacity: 1,
                        scale: 1,
                        y: 0,
                        pointerEvents: "auto",
                      }}
                      exit={{
                        opacity: 0,
                        scale: 0.8,
                        y: -10,
                        pointerEvents: "none",
                      }}
                      transition={{
                        type: "spring",
                        stiffness: 300,
                        damping: 20,
                        duration: 0.3,
                      }}
                    >
                      <motion.div
                        className="popup-menu-button"
                        onClick={handleCreateSingleEventClick}
                        whileTap={{ scale: 0.98 }}
                        transition={{
                          type: "spring",
                          stiffness: 400,
                          damping: 25,
                        }}
                      >
                        Single Event
                      </motion.div>
                      <motion.div
                        className="popup-menu-button"
                        onClick={handleCreateBulkEventClick}
                        whileTap={{ scale: 0.98 }}
                        transition={{
                          type: "spring",
                          stiffness: 400,
                          damping: 25,
                        }}
                      >
                        Bulk Event
                      </motion.div>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            )}
          </div>
        </div>
        <div className="inputCont">
          {config?.map((inputConfig, index) => (
            <InputComponent
              key={index}
              customWidth={"customWidth"}
              config={{
                ...inputConfig,
                type:
                  inputConfig.label === "School" ? "text" : inputConfig.type,
                placeholder:
                  inputConfig.label === "School" && !selectedSchool
                    ? "Code/Name"
                    : inputConfig.placeholder,
                disabled:
                  inputConfig.label === "School" &&
                  accountType === "School Admin",
                tooltip:
                  inputConfig.label === "School" &&
                  accountType === "School Admin"
                    ? "Restricted for School Admin"
                    : "",
              }}
              options={{
                ...selectdata,
                option1: schoolOptions,
                option2: gradeOptions,
              }}
              value={
                inputConfig.label === "School"
                  ? schoolInput
                  : inputConfig.label === "Grade"
                    ? selectedGrade?.value
                    : inputConfig.label === "Event"
                      ? selectedEvent
                      : ""
              }
              onChange={
                inputConfig.label === "School"
                  ? (e) => handleSchoolInputChange(e.target.value)
                  : undefined
              }
              onSelect={
                inputConfig.label === "School"
                  ? handleSchoolSelect
                  : inputConfig.label === "Grade"
                    ? handleGradeSelect
                    : inputConfig.label === "Event"
                      ? handleEventSelect
                      : undefined
              }
            />
          ))}
          <button
            onClick={handleResetFilters}
            className="planner-reset-button press-in-effect"
          >
            <img src={resetIcon} alt="Reset" />
            Reset Filters
          </button>
          <button
            onClick={() => {
              fetchEventsForSchoolAndGrade(
                selectedSchool.value,
                selectedGrade?.value || gradeOptions[0]?.value,
              );
            }}
            ref={refreshButtonRef}
            className="planner-refresh-btn"
            disabled={!selectedSchool}
            style={{ position: "relative", overflow: "hidden" }}
          >
            <RefreshIcon style={{ marginRight: "4px" }} /> Refresh
          </button>
          {selectedSchool && (
            <div className="planner-copy-button-container">
              <button
                className="planner-copy-registration-link-btn"
                onClick={() => {
                  // Extract school ID from the format "School Name - (School ID)"
                  const schoolIdMatch = selectedSchool.value.match(/\((.*?)\)/);
                  const schoolId = schoolIdMatch ? schoolIdMatch[1] : "";

                  if (schoolId) {
                    navigator.clipboard.writeText(
                      `https://inmobiusinfinitylearn.com/?school_id=${schoolId}`,
                    );
                    setShowCopyNotification(true);
                    setTimeout(() => {
                      setShowCopyNotification(false);
                    }, 2000);
                  }
                }}
              >
                Copy Registration Link
              </button>
              {showCopyNotification && (
                <div className="planner-copy-notification">Link Copied</div>
              )}
            </div>
          )}
        </div>
        <>
          {selectedSchool && (
            <div className="school-details-section">
              School:{" "}
              {selectedSchool.value.replace(" - ", " | ").replace(/[()]/g, "")}
            </div>
          )}
          {isLoading ? (
            <div className="plannerCont" style={{ justifyContent: "center" }}>
              <span
                style={{
                  textAlign: "center",
                  fontSize: "18px",
                  fontWeight: "500",
                }}
              >
                Loading please wait...
              </span>
              <img
                src={loader}
                alt="Loading..."
                style={{ textAlign: "center", height: "200px", width: "200px" }}
              />
            </div>
          ) : eventsData.length > 0 ? (
            <div className="plannerCont">
              {eventsData.map((data, index) => (
                <div key={index} className="eventbydatecont">
                  <h4 className="dateHeader">
                    {data.date}
                    {index > 0 && (
                      <span>
                        <img className="dateHeaderimg" src={line} alt="line" />
                      </span>
                    )}
                  </h4>
                  <div className="eventcardCont">
                    {data.events.map((event, index) => (
                      <EventCard
                        key={index}
                        event={event}
                        onViewDetails={handleViewEventDetails}
                        isDeleteMode={isDeleteMode}
                        onDeleteClick={handleDeleteClick}
                      />
                    ))}
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div
              className="plannerCont"
              style={{
                justifyContent: "center",
              }}
            >
              {selectedSchool && (
                <img src={noDataArt} alt="No Data" style={{ width: "200px" }} />
              )}
              <span
                style={{
                  fontSize: "18px",
                  fontWeight: "500",
                }}
              >
                {!selectedSchool
                  ? "Please select a school"
                  : "No Data Available"}
              </span>
            </div>
          )}
        </>
      </div>
      <CreateEventFormPopup
        setIsPopupVisible={setIsPopupVisible}
        isPopupVisible={isPopupVisible}
      />
      <EventDetailsPopup
        event={selectedEventDetails}
        isVisible={isEventDetailsVisible}
        onClose={handleCloseEventDetails}
      />
      <DeleteEventPopup
        event={selectedEventDetails}
        isVisible={isDeletePopupVisible}
        onClose={() => setIsDeletePopupVisible(false)}
        onConfirm={handleDeleteConfirm}
      />
      <UploadPopUp
        isOpen={isUploadModalVisible}
        handleCloseModal={handleCloseUploadModal}
        uploadType={uploadType}
        schoolId={selectedSchool?.value?.match(/\((.*?)\)/)?.[1] || ""}
      />
    </>
  );
};

export default Planner;
